// extracted by mini-css-extract-plugin
module.exports = {"module":"EmptyCartPanel_module__TuR-c","inner":"EmptyCartPanel_inner__WYLmP"};